//SingleProject.js
///////////////////////////////
//React & Material
import React, {useState,useEffect} from 'react';
import { Col, Row, Image } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
//Plugins
import styled from 'styled-components';
import MainImage from '../../media/projects/1.Biorific/biorific-main.svg';
import SolutionImage from '../../media/projects/1.Biorific/biorific-solution.png';
import PlantRound from '../../media/projects/1.Biorific/Organization Dashboard Round.png';
import DashRound from '../../media/projects/1.Biorific/Admin Dashboard Round.png';
import EndVector from '../../media/projects/projects-end.svg';
import GithubLogo from '../../media/projects/github-logo.svg';
import StackVector from '../../media/projects/stack-vector.svg';
import NextArrow from '../../media/projects/next-arrow.svg';
import BackA from '../../media/go-back.svg';
import BackHover from '../../media/go-back-onhover.svg'

import { useHistory,Link,withRouter} from "react-router-dom";
//Component Imports

//////////////////////////////
//Styled components
const Wrapper = styled(Container)`
  padding:40px;
`
const CustomRow = styled(Row)`
  margin-top:${props => props.marginTop};
  
`

const SolutionContainer = styled.div`
  margin-top:${props => props.marginTop};
  
`
const ProjectTitle = styled.h1`
  font-size:50px;
  margin-left:5vw;
`
const G = styled.span`
  color:#36FFC1;
`

const OverviewRow = styled(Row)`
margin-top:5vh;
align-items:flex-end;
justify-content:flex-end;
flex-direction: column;
`
const SubOverview = styled(Row)`
align-items:flex-start;
justify-content:flex-start;
flex-direction: column;
`
const RoleOverview = styled(Row)`
align-items:flex-start;
justify-content:flex-start;
flex-direction: row;
text-align: left;
margin-top:2vh;
`

const RoleCol = styled(Col)`
// text-align: left;
margin-right:5vw;
`
const SubHeading = styled.h3`
color: rgba(255, 255, 255, 0.35);
margin-bottom:1vh;

&:hover{
  color:white;
}
`
const SubText = styled.h4`
color: rgba(255, 255, 255, 0.35);
margin-bottom:1vh;

&:hover{
  color:white;
}
`

const SubTextStack = styled.p`
color: rgba(255, 255, 255, 0.35);
margin-bottom:1vh;
&:hover{
  color:white;
}
`
const CustomCol = styled(Col)`
justify-content:flex-end;
text-align:left;
margin-left:3vw;
align-self: flex-end;
`

const JustifiedText = styled.h4`
text-align:justify;
`

const QuestionText = styled.h1`
color: rgba(255, 255, 255, 0.35);
// margin-bottom:1vh;

&:hover{
  color:white;
}
`

const QuestionMark = styled.h1`
font-size:10em;
font-style:italic;
color: rgba(255, 255, 255, 0.35);
`

const QuestionF = styled(Row)`
justify-content:flex-start;
margin-left:7vw;
margin-bottom: -2vh;
`
const QuestionM = styled(Row)`
justify-content:center;
margin-bottom: -2vh;
`
const QuestionLast = styled(Row)`
justify-content:flex-end;
margin-right:7vw;
`

const Solution = styled(Image)`
// height:1000px;
// padding:40px;
max-width: 100%;
height: auto;
// width: 100%;
// height: auto;
`
const ProcessRow = styled(Row)`
 margin-left:${props => props.marginLeft};
margin-top:1vh;
`

const ProcessStep = styled.h3`
margin-left:1vw;
`

const EndImages = styled(Image)`
  height:500px;
`

const BackgroundContainer = styled(Container)`
  background: url(${EndVector});
  background-size: contain;
  background-repeat: no-repeat;

`

const SmallRow = styled(Row)`
  width:500px;
  text-align:left;
  margin-top:2vh;
`

const StackCol = styled(Col)`
  text-align:left;
  justify-content: flex-end;
    align-items: flex-end;
    display: flex;
    flex-direction: column;
`

const EndText = styled.h2`
font-weight: bold;
color:${props => props.color};
text-align:left;
`
const GitRow = styled.div`
  display:flex;
  justify-content:flex-start;
  align-content:center;
  flex-direction:row;
`

const GitCol = styled.div`
  display:flex;
  justify-content:center;
  align-content:center;
  margin-right:20px;
`
const CodebaseText = styled.h3`
color: rgba(255, 255, 255, 0.35);
margin-bottom:0;
&:hover{
  color:white;
}
`

const EndContainer = styled(Container)`
  width:30vw;
`
const StackContainer = styled(Container)`
text-align: left;
`
const StackOv = styled(Row)`
align-items:flex-start;
justify-content:flex-start;
flex-direction: row;
`
const StackOv2 = styled(Row)`
align-items:center;
justify-content:center;
flex-direction: row;
margin-top:20px;
`

const StackSingle = styled(Row)`
display:relative;
`
const StackSvg = styled(Image)`
position: absolute;
left: -8px;
/* bottom: 43px; */
top: -0.7vh;

`

const TechName = styled.h4`
z-index:1;
`
const EndDiv = styled.div`
display:flex;
flex-direction:column;
align-items: center;
`
const Arrow = styled.span`

`

const GoBackSection = styled(Link)`
  display:flex;
  align-items:center;
  justify-content:center;
  margin-bottom:3vh;
  &:focus, &:hover, &:visited, &:link, &:active {
    text-decoration: none;
  }
`

const BackArrow = styled(Image)`
margin-right:10px;
`

const BackText = styled.h2`
font-weight: bold;
line-height: 35px;
font-size:1.5em;
color:${props => props.color};
`

const CustomLink = styled.div`
text-decoration: none;
-webkit-transition: color 1s ease-out;
-moz-transition: color 1s ease-out;
-o-transition: color 1s ease-out;
-ms-transition: color 1s ease-out;
transition: color 1s ease-out;
    &:focus, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }
    
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function SingleProject(props) {

  const [backHover, setBackHover] = useState(false);
  var x = 30;
  let history = useHistory();



  const TextHeading = (marginTop, title, content) => {
    return (
      <CustomRow marginTop={marginTop}>
        <Row>
          <SubHeading>
            {title}<G>.</G>
          </SubHeading>
        </Row>
        <Row>
          <JustifiedText>
            {content}
          </JustifiedText>
        </Row>
      </CustomRow>
    )
  }

  const ProcessS = (no, desc) => {
    // increases the margin by 10vw everytime the function gets called
    { x = x + 100 }
    return (
      <ProcessRow marginLeft={`${x}px`}>
        <SubHeading>
          {no}
        </SubHeading>
        <ProcessStep>{desc}</ProcessStep>
      </ProcessRow>
    )
  }

  const GenerateTextStack = (heading, desc) => {
    return (
      <Col>
        <StackContainer>
          <StackSingle>
            <StackSvg src={StackVector} />
            <TechName>
              {heading} <br />
            </TechName>
          </StackSingle>
          <Row>
            <SubTextStack>
              {desc}
            </SubTextStack>
          </Row>
        </StackContainer>
      </Col>

    )
  }


  return (
    <Wrapper>
      {/* Title Section  */}
      <CustomRow marginTop="4vh">
       
        <GoBackSection  onClick={()=>history.push('/')}onMouseEnter={()=> {setBackHover(true)}} onMouseLeave={()=> {setBackHover(false)}}>
          <BackArrow src={!backHover ? BackA : BackHover} fluid />
          <BackText color={!backHover ? "rgba(255, 255, 255, 0.48)" : "#36FFC1"}>go back</BackText>
        </GoBackSection>
        
      </CustomRow>
      <Row> 
      <ProjectTitle>
        Biorific<G>.</G>
      </ProjectTitle>
      </Row>
      <OverviewRow>
        <SubOverview>
          <h3>
            Your trusted remote plant monitoring solution<G>.</G>
          </h3>
          <RoleOverview>
            <RoleCol>
              <h3>
                <SubHeading>
                  Role <br />
                </SubHeading>
        Team lead <G>+</G> Front-end dev<G>.</G>
              </h3>
            </RoleCol>
            <RoleCol>
              <h3>
                <SubHeading>
                  Date <br />
                </SubHeading>
        Mar 2020<G>.</G>
              </h3>
            </RoleCol>
          </RoleOverview>
        </SubOverview>
      </OverviewRow>

      {/* Introduction Section */}
      <CustomRow marginTop="8vh">
        <Col>
          <Image fluid src={MainImage} />
        </Col>
        <CustomCol>
          <Row>
            <h3>
              Biorific is a solution to remote plant monitoring for everyone. <br /><br />
              <SubText>
                Capture how your plant's surroundings are tracking, including the moisture in the soil, the amount of light your plant is getting and the temperature of its environment from anywhere in the world.
          </SubText>
            </h3>
          </Row>
        </CustomCol>
      </CustomRow>

      {/* Challenge Section */}
      {TextHeading("10vh", "The challenge", "Nearly 5 million patients each month use ZocDoc products to find in-network doctors. While the average national wait time to see a doctor is nearly three weeks, the majority of ZocDoc appointments take place within 24 – 72 hours.")}

      {/* Question Section */}
      <CustomRow marginTop="8vh">
        <Container>
          <QuestionF noGutters>
            <QuestionText> what did we do <G>?</G></QuestionText>
          </QuestionF>
          <QuestionM noGutters>
            <QuestionMark>
              &
            </QuestionMark>
          </QuestionM>
          <QuestionLast noGutters>
            <QuestionText> how did we do it <G>?</G></QuestionText>
          </QuestionLast>
        </Container>
      </CustomRow>

      {/* Solution Section */}
      {TextHeading("5vh", "The solution", "I designed a solution that can help verify the doctor’s current status with the medical insurance carrier. This would be an additional step to verify that the doctor is indeed in-network and would accept the patient's medical plan.")}

      {/* Project Solution */}
      <SolutionContainer marginTop="8vh">
        <Solution fluid src={SolutionImage} />
      </SolutionContainer>

      {/* The Process */}
      <CustomRow marginTop="2vh">
        <Container>
          <Row>
            <SubHeading>
              The process<G>.</G>
            </SubHeading>
          </Row>
          {ProcessS("01", "research")}
          {ProcessS("02", "defining the problem")}
          {ProcessS("03", "framing the solution")}
          {ProcessS("04", "developing the solution")}
          {ProcessS("05", "finalizing")}
        </Container>
      </CustomRow>


      {/* The End Vectors */}
      <CustomRow marginTop="8vh">
        <BackgroundContainer>
          <RoleOverview>
            <EndImages fluid src={DashRound} />
          </RoleOverview>
          <OverviewRow>
            <EndImages fluid src={PlantRound} />
          </OverviewRow>
        </BackgroundContainer>
      </CustomRow>


      {/* The Conclusion */}
      <CustomRow marginTop="10vh">
        <Container>
          <Row>
            <h3>Blazing fast and easily scalable<G>.</G></h3>
          </Row>
          <SmallRow>
            <SubText>
              Capture how your plant's surroundings are tracking, including the moisture in the soil, the amount of light your plant is getting and the temperature of its environment from anywhere in the world.
          </SubText>
          </SmallRow>
        </Container>
      </CustomRow>

      {/* Tech Stack Section  */}
      <Wrapper>
        <OverviewRow>
          <EndDiv>
            <StackOv>
              {GenerateTextStack("React", "javascript library")}
              {GenerateTextStack("Netlify", "hosting provider")}
              {GenerateTextStack("Prismic", "content management")}
            </StackOv>
            <StackOv2>
              {GenerateTextStack("Python", "backend language")}
              {GenerateTextStack("Ec2", "people relation")}
            </StackOv2>
          </EndDiv>
        </OverviewRow>
      </Wrapper>


      {/* The End */}
      <CustomRow marginTop="8vh">
        <EndContainer>
          <GitRow>
            <GitCol>
              <Image src={GithubLogo} />
            </GitCol>
            <GitCol>
              <EndText>
                visit
                <CodebaseText>
                  github codebase
                </CodebaseText>
              </EndText>
            </GitCol>
          </GitRow>
          <OverviewRow>
            <EndText color="#36FFC1">
              Munchys <Arrow><Image src={NextArrow} fluid /></Arrow><br />
              <SubHeading>
                next project
            </SubHeading>
            </EndText>
          </OverviewRow>
        </EndContainer>
      </CustomRow>

    </Wrapper>
  )
}
export default withRouter(SingleProject);